import { Main, Group, Container } from "../index";
import afterInit from "./Main/listeners/events/after-init";
import reloadGlobalListeners from "./Main/store/utils/reload-global-listeners";
import WINDOW from "../src/utils/window";
import beforeMutation from "./utils/initialization/before-mutations";
import getIterableElements from "./utils/get-iterable-elements";
import setPlatform from "./utils/set-platform";

/**
 * Manual TorusKit initialization
 * @param {IterableElementsProps | null} [targets]
 */
const init = (targets = null) => {
  /** @type {Array<TorusElement>} */
  let mains;

  /** @type {Array<TorusElement>} */
  let groups;

  /** @type {Array<TorusElement>} */
  let containers;

  const observers = /** @type {WindowObserverProps} */ (
    WINDOW.get("observers")
  );

  if (!observers.get("mutation")) {
    beforeMutation(true);
  }

  if (targets) {
    const elements = getIterableElements(targets) || [];

    groups = /** @type {Array<TorusElement>} */ (
      elements.filter((item) => item.hasAttribute("data-tor-group"))
    );
  } else {
    groups = /** @type {Array<TorusElement>} */ ([
      ...document.querySelectorAll("[data-tor-group]"),
    ]);
  }

  Group.init(groups);

  if (targets) {
    const elements = getIterableElements(targets) || [];

    mains = /** @type {Array<TorusElement>} */ (
      elements.filter((item) => item.hasAttribute("data-tor"))
    );
  } else {
    mains = /** @type {Array<TorusElement>} */ ([
      ...document.querySelectorAll("[data-tor]"),
    ]);
  }

  Main.init(mains);

  if (targets) {
    const elements = getIterableElements(targets) || [];

    containers = /** @type {Array<TorusElement>} */ (
      elements.filter((item) => item.hasAttribute("data-tor-container"))
    );
  } else {
    containers = /** @type {Array<TorusElement>} */ ([
      ...document.querySelectorAll("[data-tor-container]"),
    ]);
  }

  Container.init(containers);

  afterInit(mains ? mains : null);
  reloadGlobalListeners();
  setPlatform();
};

export default init;
